import {type DropdownItemProps} from 'semantic-ui-react';

// This list of country code and name came from the stripe's
// address input country options when using PaymentElement
export const COUNTRY_CODE_NAME_OPTIONS: DropdownItemProps[] = [
  {key: 'US', text: 'United States', value: 'US'},
  {key: 'AF', text: 'Afghanistan', value: 'AF'},
  {key: 'AX', text: 'Åland Islands', value: 'AX'},
  {key: 'AL', text: 'Albania', value: 'AL'},
  {key: 'DZ', text: 'Algeria', value: 'DZ'},
  {key: 'AD', text: 'Andorra', value: 'AD'},
  {key: 'AO', text: 'Angola', value: 'AO'},
  {key: 'AI', text: 'Anguilla', value: 'AI'},
  {key: 'AQ', text: 'Antarctica', value: 'AQ'},
  {key: 'AG', text: 'Antigua &amp; Barbuda', value: 'AG'},
  {key: 'AR', text: 'Argentina', value: 'AR'},
  {key: 'AM', text: 'Armenia', value: 'AM'},
  {key: 'AW', text: 'Aruba', value: 'AW'},
  {key: 'AU', text: 'Australia', value: 'AU'},
  {key: 'AT', text: 'Austria', value: 'AT'},
  {key: 'AZ', text: 'Azerbaijan', value: 'AZ'},
  {key: 'BS', text: 'Bahamas', value: 'BS'},
  {key: 'BH', text: 'Bahrain', value: 'BH'},
  {key: 'BD', text: 'Bangladesh', value: 'BD'},
  {key: 'BB', text: 'Barbados', value: 'BB'},
  {key: 'BY', text: 'Belarus', value: 'BY'},
  {key: 'BE', text: 'Belgium', value: 'BE'},
  {key: 'BZ', text: 'Belize', value: 'BZ'},
  {key: 'BJ', text: 'Benin', value: 'BJ'},
  {key: 'BM', text: 'Bermuda', value: 'BM'},
  {key: 'BT', text: 'Bhutan', value: 'BT'},
  {key: 'BO', text: 'Bolivia', value: 'BO'},
  {key: 'BA', text: 'Bosnia &amp; Herzegovina', value: 'BA'},
  {key: 'BW', text: 'Botswana', value: 'BW'},
  {key: 'BV', text: 'Bouvet Island', value: 'BV'},
  {key: 'BR', text: 'Brazil', value: 'BR'},
  {key: 'IO', text: 'British Indian Ocean Territory', value: 'IO'},
  {key: 'VG', text: 'British Virgin Islands', value: 'VG'},
  {key: 'BN', text: 'Brunei', value: 'BN'},
  {key: 'BG', text: 'Bulgaria', value: 'BG'},
  {key: 'BF', text: 'Burkina Faso', value: 'BF'},
  {key: 'BI', text: 'Burundi', value: 'BI'},
  {key: 'KH', text: 'Cambodia', value: 'KH'},
  {key: 'CM', text: 'Cameroon', value: 'CM'},
  {key: 'CA', text: 'Canada', value: 'CA'},
  {key: 'CV', text: 'Cape Verde', value: 'CV'},
  {key: 'BQ', text: 'Caribbean Netherlands', value: 'BQ'},
  {key: 'KY', text: 'Cayman Islands', value: 'KY'},
  {key: 'CF', text: 'Central African Republic', value: 'CF'},
  {key: 'TD', text: 'Chad', value: 'TD'},
  {key: 'CL', text: 'Chile', value: 'CL'},
  {key: 'CN', text: 'China', value: 'CN'},
  {key: 'CO', text: 'Colombia', value: 'CO'},
  {key: 'KM', text: 'Comoros', value: 'KM'},
  {key: 'CG', text: 'Congo - Brazzaville', value: 'CG'},
  {key: 'CD', text: 'Congo - Kinshasa', value: 'CD'},
  {key: 'CK', text: 'Cook Islands', value: 'CK'},
  {key: 'CR', text: 'Costa Rica', value: 'CR'},
  {key: 'CI', text: 'Côte d’Ivoire', value: 'CI'},
  {key: 'HR', text: 'Croatia', value: 'HR'},
  {key: 'CW', text: 'Curaçao', value: 'CW'},
  {key: 'CY', text: 'Cyprus', value: 'CY'},
  {key: 'CZ', text: 'Czechia', value: 'CZ'},
  {key: 'DK', text: 'Denmark', value: 'DK'},
  {key: 'DJ', text: 'Djibouti', value: 'DJ'},
  {key: 'DM', text: 'Dominica', value: 'DM'},
  {key: 'DO', text: 'Dominican Republic', value: 'DO'},
  {key: 'EC', text: 'Ecuador', value: 'EC'},
  {key: 'EG', text: 'Egypt', value: 'EG'},
  {key: 'SV', text: 'El Salvador', value: 'SV'},
  {key: 'GQ', text: 'Equatorial Guinea', value: 'GQ'},
  {key: 'ER', text: 'Eritrea', value: 'ER'},
  {key: 'EE', text: 'Estonia', value: 'EE'},
  {key: 'SZ', text: 'Eswatini', value: 'SZ'},
  {key: 'ET', text: 'Ethiopia', value: 'ET'},
  {key: 'FK', text: 'Falkland Islands', value: 'FK'},
  {key: 'FO', text: 'Faroe Islands', value: 'FO'},
  {key: 'FJ', text: 'Fiji', value: 'FJ'},
  {key: 'FI', text: 'Finland', value: 'FI'},
  {key: 'FR', text: 'France', value: 'FR'},
  {key: 'GF', text: 'French Guiana', value: 'GF'},
  {key: 'PF', text: 'French Polynesia', value: 'PF'},
  {key: 'TF', text: 'French Southern Territories', value: 'TF'},
  {key: 'GA', text: 'Gabon', value: 'GA'},
  {key: 'GM', text: 'Gambia', value: 'GM'},
  {key: 'GE', text: 'Georgia', value: 'GE'},
  {key: 'DE', text: 'Germany', value: 'DE'},
  {key: 'GH', text: 'Ghana', value: 'GH'},
  {key: 'GI', text: 'Gibraltar', value: 'GI'},
  {key: 'GR', text: 'Greece', value: 'GR'},
  {key: 'GL', text: 'Greenland', value: 'GL'},
  {key: 'GD', text: 'Grenada', value: 'GD'},
  {key: 'GP', text: 'Guadeloupe', value: 'GP'},
  {key: 'GU', text: 'Guam', value: 'GU'},
  {key: 'GT', text: 'Guatemala', value: 'GT'},
  {key: 'GG', text: 'Guernsey', value: 'GG'},
  {key: 'GN', text: 'Guinea', value: 'GN'},
  {key: 'GW', text: 'Guinea-Bissau', value: 'GW'},
  {key: 'GY', text: 'Guyana', value: 'GY'},
  {key: 'HT', text: 'Haiti', value: 'HT'},
  {key: 'HN', text: 'Honduras', value: 'HN'},
  {key: 'HK', text: 'Hong Kong SAR China', value: 'HK'},
  {key: 'HU', text: 'Hungary', value: 'HU'},
  {key: 'IS', text: 'Iceland', value: 'IS'},
  {key: 'IN', text: 'India', value: 'IN'},
  {key: 'ID', text: 'Indonesia', value: 'ID'},
  {key: 'IQ', text: 'Iraq', value: 'IQ'},
  {key: 'IE', text: 'Ireland', value: 'IE'},
  {key: 'IM', text: 'Isle of Man', value: 'IM'},
  {key: 'IL', text: 'Israel', value: 'IL'},
  {key: 'IT', text: 'Italy', value: 'IT'},
  {key: 'JM', text: 'Jamaica', value: 'JM'},
  {key: 'JP', text: 'Japan', value: 'JP'},
  {key: 'JE', text: 'Jersey', value: 'JE'},
  {key: 'JO', text: 'Jordan', value: 'JO'},
  {key: 'KZ', text: 'Kazakhstan', value: 'KZ'},
  {key: 'KE', text: 'Kenya', value: 'KE'},
  {key: 'KI', text: 'Kiribati', value: 'KI'},
  {key: 'XK', text: 'Kosovo', value: 'XK'},
  {key: 'KW', text: 'Kuwait', value: 'KW'},
  {key: 'KG', text: 'Kyrgyzstan', value: 'KG'},
  {key: 'LA', text: 'Laos', value: 'LA'},
  {key: 'LV', text: 'Latvia', value: 'LV'},
  {key: 'LB', text: 'Lebanon', value: 'LB'},
  {key: 'LS', text: 'Lesotho', value: 'LS'},
  {key: 'LR', text: 'Liberia', value: 'LR'},
  {key: 'LY', text: 'Libya', value: 'LY'},
  {key: 'LI', text: 'Liechtenstein', value: 'LI'},
  {key: 'LT', text: 'Lithuania', value: 'LT'},
  {key: 'LU', text: 'Luxembourg', value: 'LU'},
  {key: 'MO', text: 'Macao SAR China', value: 'MO'},
  {key: 'MG', text: 'Madagascar', value: 'MG'},
  {key: 'MW', text: 'Malawi', value: 'MW'},
  {key: 'MY', text: 'Malaysia', value: 'MY'},
  {key: 'MV', text: 'Maldives', value: 'MV'},
  {key: 'ML', text: 'Mali', value: 'ML'},
  {key: 'MT', text: 'Malta', value: 'MT'},
  {key: 'MQ', text: 'Martinique', value: 'MQ'},
  {key: 'MR', text: 'Mauritania', value: 'MR'},
  {key: 'MU', text: 'Mauritius', value: 'MU'},
  {key: 'YT', text: 'Mayotte', value: 'YT'},
  {key: 'MX', text: 'Mexico', value: 'MX'},
  {key: 'MD', text: 'Moldova', value: 'MD'},
  {key: 'MC', text: 'Monaco', value: 'MC'},
  {key: 'MN', text: 'Mongolia', value: 'MN'},
  {key: 'ME', text: 'Montenegro', value: 'ME'},
  {key: 'MS', text: 'Montserrat', value: 'MS'},
  {key: 'MA', text: 'Morocco', value: 'MA'},
  {key: 'MZ', text: 'Mozambique', value: 'MZ'},
  {key: 'MM', text: 'Myanmar (Burma)', value: 'MM'},
  {key: 'NA', text: 'Namibia', value: 'NA'},
  {key: 'NR', text: 'Nauru', value: 'NR'},
  {key: 'NP', text: 'Nepal', value: 'NP'},
  {key: 'NL', text: 'Netherlands', value: 'NL'},
  {key: 'NC', text: 'New Caledonia', value: 'NC'},
  {key: 'NZ', text: 'New Zealand', value: 'NZ'},
  {key: 'NI', text: 'Nicaragua', value: 'NI'},
  {key: 'NE', text: 'Niger', value: 'NE'},
  {key: 'NG', text: 'Nigeria', value: 'NG'},
  {key: 'NU', text: 'Niue', value: 'NU'},
  {key: 'MK', text: 'North Macedonia', value: 'MK'},
  {key: 'NO', text: 'Norway', value: 'NO'},
  {key: 'OM', text: 'Oman', value: 'OM'},
  {key: 'PK', text: 'Pakistan', value: 'PK'},
  {key: 'PS', text: 'Palestinian Territories', value: 'PS'},
  {key: 'PA', text: 'Panama', value: 'PA'},
  {key: 'PG', text: 'Papua New Guinea', value: 'PG'},
  {key: 'PY', text: 'Paraguay', value: 'PY'},
  {key: 'PE', text: 'Peru', value: 'PE'},
  {key: 'PH', text: 'Philippines', value: 'PH'},
  {key: 'PN', text: 'Pitcairn Islands', value: 'PN'},
  {key: 'PL', text: 'Poland', value: 'PL'},
  {key: 'PT', text: 'Portugal', value: 'PT'},
  {key: 'PR', text: 'Puerto Rico', value: 'PR'},
  {key: 'QA', text: 'Qatar', value: 'QA'},
  {key: 'RE', text: 'Réunion', value: 'RE'},
  {key: 'RO', text: 'Romania', value: 'RO'},
  {key: 'RU', text: 'Russia', value: 'RU'},
  {key: 'RW', text: 'Rwanda', value: 'RW'},
  {key: 'WS', text: 'Samoa', value: 'WS'},
  {key: 'SM', text: 'San Marino', value: 'SM'},
  {key: 'ST', text: 'São Tomé &amp; Príncipe', value: 'ST'},
  {key: 'SA', text: 'Saudi Arabia', value: 'SA'},
  {key: 'SN', text: 'Senegal', value: 'SN'},
  {key: 'RS', text: 'Serbia', value: 'RS'},
  {key: 'SC', text: 'Seychelles', value: 'SC'},
  {key: 'SL', text: 'Sierra Leone', value: 'SL'},
  {key: 'SG', text: 'Singapore', value: 'SG'},
  {key: 'SX', text: 'Sint Maarten', value: 'SX'},
  {key: 'SK', text: 'Slovakia', value: 'SK'},
  {key: 'SI', text: 'Slovenia', value: 'SI'},
  {key: 'SB', text: 'Solomon Islands', value: 'SB'},
  {key: 'SO', text: 'Somalia', value: 'SO'},
  {key: 'ZA', text: 'South Africa', value: 'ZA'},
  {key: 'GS', text: 'South Georgia &amp; South Sandwich Islands', value: 'GS'},
  {key: 'KR', text: 'South Korea', value: 'KR'},
  {key: 'SS', text: 'South Sudan', value: 'SS'},
  {key: 'ES', text: 'Spain', value: 'ES'},
  {key: 'LK', text: 'Sri Lanka', value: 'LK'},
  {key: 'BL', text: 'St. Barthélemy', value: 'BL'},
  {key: 'SH', text: 'St. Helena', value: 'SH'},
  {key: 'KN', text: 'St. Kitts &amp; Nevis', value: 'KN'},
  {key: 'LC', text: 'St. Lucia', value: 'LC'},
  {key: 'MF', text: 'St. Martin', value: 'MF'},
  {key: 'PM', text: 'St. Pierre &amp; Miquelon', value: 'PM'},
  {key: 'VC', text: 'St. Vincent &amp; Grenadines', value: 'VC'},
  {key: 'SR', text: 'Suriname', value: 'SR'},
  {key: 'SJ', text: 'Svalbard &amp; Jan Mayen', value: 'SJ'},
  {key: 'SE', text: 'Sweden', value: 'SE'},
  {key: 'CH', text: 'Switzerland', value: 'CH'},
  {key: 'TW', text: 'Taiwan', value: 'TW'},
  {key: 'TJ', text: 'Tajikistan', value: 'TJ'},
  {key: 'TZ', text: 'Tanzania', value: 'TZ'},
  {key: 'TH', text: 'Thailand', value: 'TH'},
  {key: 'TL', text: 'Timor-Leste', value: 'TL'},
  {key: 'TG', text: 'Togo', value: 'TG'},
  {key: 'TK', text: 'Tokelau', value: 'TK'},
  {key: 'TO', text: 'Tonga', value: 'TO'},
  {key: 'TT', text: 'Trinidad &amp; Tobago', value: 'TT'},
  {key: 'TA', text: 'Tristan da Cunha', value: 'TA'},
  {key: 'TN', text: 'Tunisia', value: 'TN'},
  {key: 'TR', text: 'Turkey', value: 'TR'},
  {key: 'TM', text: 'Turkmenistan', value: 'TM'},
  {key: 'TC', text: 'Turks &amp; Caicos Islands', value: 'TC'},
  {key: 'TV', text: 'Tuvalu', value: 'TV'},
  {key: 'UG', text: 'Uganda', value: 'UG'},
  {key: 'UA', text: 'Ukraine', value: 'UA'},
  {key: 'AE', text: 'United Arab Emirates', value: 'AE'},
  {key: 'GB', text: 'United Kingdom', value: 'GB'},
  {key: 'UY', text: 'Uruguay', value: 'UY'},
  {key: 'UZ', text: 'Uzbekistan', value: 'UZ'},
  {key: 'VU', text: 'Vanuatu', value: 'VU'},
  {key: 'VA', text: 'Vatican City', value: 'VA'},
  {key: 'VE', text: 'Venezuela', value: 'VE'},
  {key: 'VN', text: 'Vietnam', value: 'VN'},
  {key: 'WF', text: 'Wallis &amp; Futuna', value: 'WF'},
  {key: 'EH', text: 'Western Sahara', value: 'EH'},
  {key: 'YE', text: 'Yemen', value: 'YE'},
  {key: 'ZM', text: 'Zambia', value: 'ZM'},
  {key: 'ZW', text: 'Zimbabwe', value: 'ZW'},
];
